// Using Object Literal as Singleton Pattern
// Warning: Only add server-side application state here, not request-specific or client-side data

const Application: Site.Application = {
	envVars: null,

	setEnvVar(key, value): { [key: string]: string } {
		this.envVars = this.envVars ?? {};
		this.envVars[key] = value;
		return this.envVars[key];
	},
};

export default Application;
